<div class="modal-header">
    <h5 class="modal-title w-100">
        <div class="alert-icon d-flex justify-content-center mb-4">
            <img src="/assets/images/alert.png" height="70px" width="auto" />
        </div>
        <p class="text d-block text-center">{{title || 'N/A'}}</p>
    </h5>
    <span *ngIf="closeBtn" class="fa fa-close" aria-label="Close" (click)="activeModal.close('close')"></span>
</div>
<div class="modal-body w-100 text-center">
    <div>
        <p class="text">{{message1 || 'N/A'}}</p>
        <br>
        <ng-container *ngIf="message2">
            <p class="text">{{message2}}</p>
            <br>
        </ng-container>
    </div>
    <div *ngIf="showMilstdGlbToggle" class="milstdglb-toggle d-flex align-items-center justify-content-center">
        <span class="toggle-label text-left" [innerHTML]="glbMessage"></span>
        <div class="toggle d-flex align-items-center ml-3">
            <span class="mr-1">YES</span>
            <label class="switch m-0">
                <input type="checkbox" [checked]="useMilstdGlb" (change)="onMilstdGlbToggle($event)" />
                <span class="slider round"></span>
            </label>
            <span class="ml-1">NO</span>
        </div>
    </div>
    <span *ngIf="message3" class="d-block">
        <p class="dynamics-message">{{message3}}</p>
    </span>
</div>
<div class="modal-footer w-100 d-flex flex-column">
    <div class="row flat">
        <div class="col">
            <p class="text">{{confirm_message}}</p>
        </div>
    </div>
    <div class="w-100 action-buttons d-flex align-items-center justify-content-between gap-1">
        <button type="button" class="btn btn-primary" (click)="activeModal.close('cancel')">{{no_label ||
            'NO'}}</button>
        <button type="button" class="btn btn-primary" (click)="onConfirm()">{{yes_label || 'YES'}}</button>
    </div>
</div>